import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import MovementReportService from '_services/movement-report-service';

export const fetchMovementReport = createAsyncThunk(
  'movementReport/fetch',
  async (params, { signal }) => {
    return await MovementReportService.getMovementReport(params, signal);
  }
);

export const patchBooking = createAsyncThunk(
  'movementReport/patchBooking',
  async ({ bookingId, patch, reportParams }) => {
    await MovementReportService.patchBooking(bookingId, patch);
    return reportParams;
  }
);

const initialState = {
  data: null,
  status: 'idle',
  error: null,
  patchStatus: 'idle',
  patchError: null,
};

const movementReportSlice = createSlice({
  name: 'movementReport',
  initialState,
  reducers: {
    resetMovementReport: (state) => {
      state.data = null;
      state.status = 'idle';
      state.error = null;
    },
    resetPatchBookingStatus: (state) => {
      state.patchStatus = 'idle';
      state.patchError = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchMovementReport.pending, (state) => {
        state.status = 'loading';
        state.error = null;
      })
      .addCase(fetchMovementReport.fulfilled, (state, action) => {
        state.status = 'succeeded';
        state.data = action.payload;
        state.error = null;
      })
      .addCase(fetchMovementReport.rejected, (state, action) => {
        state.status = 'failed';
        state.error = action.error.message;
      })
      .addCase(patchBooking.pending, (state) => {
        state.patchStatus = 'loading';
        state.patchError = null;
      })
      .addCase(patchBooking.fulfilled, (state) => {
        state.patchStatus = 'succeeded';
        state.patchError = null;
      })
      .addCase(patchBooking.rejected, (state, action) => {
        state.patchStatus = 'failed';
        state.patchError = action.error.message;
      });
  },
});

export const selectMovementReportData = (state) => state.movementReport.data;
export const selectMovementReportStatus = (state) => state.movementReport.status;
export const selectMovementReportError = (state) => state.movementReport.error;
export const selectPatchBookingStatus = (state) => state.movementReport.patchStatus;
export const selectPatchBookingError = (state) => state.movementReport.patchError;

export const { resetMovementReport, resetPatchBookingStatus } = movementReportSlice.actions;

export default movementReportSlice.reducer;
